class Tab extends HTMLElement {
  constructor() {
    super();
    this.buttons = document.querySelectorAll('[data-tab]')

    this.buttons.forEach((button, index) => {
      button.addEventListener('click', (e) => {
        this.change(e)
      }, false)
    })
  }

  clear() {
    const buttons = document.querySelectorAll('[data-tab]')
    buttons.forEach((button) => {
      button.classList.remove('active')
      const id = button.getAttribute('data-tab')
      document.getElementById(id).classList.remove('active')
    })
  }

  change(e) {
    this.clear()
    e.target.classList.add('active')
    const id = e.currentTarget.getAttribute('data-tab')
    document.getElementById(id).classList.add('active')
  }
}

customElements.define('blog-tabs', Tab)

class TabPane {
  constructor(element) {
    this.element = element
    setupCustomElement(this.element)
  }
}

function setupCustomElement(tab) {
  const tagString = tab.getAttribute('data-tags')
  const arr = tagString.toLowerCase().split(',')
  let str = ''

  arr.forEach((item) => {
    if (item !== '') {
      if (str === '') {
        str = item
      } else {
        str += ' OR ' + item
      }
    }
  })

  if (arr.length > 0) {
      fetch(`/search/suggest?q=${str}&resources[type]=article&resources[limit]=4&section_id=blog-related-posts-search`).then(res => {
        if (!res.ok) {
          throw new Error()
        }

        return res.text()
      }).then(data => {
        tab.innerHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('#shopify-section-blog-related-posts-search').innerHTML
      })
    }
}

function initilizeTabs() {
  const tabElements = document.querySelectorAll('[data-tags]')
  tabElements.forEach(element => {new TabPane(element)})
}

initilizeTabs()

customElements.define('tab-pane', TabPane)
